import {
    WEB_BOOK_STRIPE_PRODUCT_LIVE_API_ID,
    WEB_BOOK_STRIPE_PRODUCT_TEST_API_ID,
    DIGITAL_BOOK_STRIPE_PRODUCT_LIVE_API_ID,
    DIGITAL_BOOK_STRIPE_PRODUCT_TEST_API_ID,
    DIGITAL_BOOK_PREORDER_STRIPE_PRODUCT_LIVE_API_ID,
    DIGITAL_BOOK_PREORDER_STRIPE_PRODUCT_TEST_API_ID,
    PHYSICAL_BOOK_STRIPE_PRODUCT_LIVE_API_ID,
    PHYSICAL_BOOK_STRIPE_PRODUCT_TEST_API_ID,
    PHYSICAL_BOOK_PREORDER_STRIPE_PRODUCT_LIVE_API_ID,
    PHYSICAL_BOOK_PREORDER_STRIPE_PRODUCT_TEST_API_ID,
}                       from '../constants/generalConstants';
import { ICartItem }     from '../interfaces';

export interface ICartBookInviteNote {
    productId: string,
    text: string,
}

const PHYSICAL_PRODUCT_IDS = new Set([
    PHYSICAL_BOOK_STRIPE_PRODUCT_LIVE_API_ID,
    PHYSICAL_BOOK_STRIPE_PRODUCT_TEST_API_ID,
    PHYSICAL_BOOK_PREORDER_STRIPE_PRODUCT_LIVE_API_ID,
    PHYSICAL_BOOK_PREORDER_STRIPE_PRODUCT_TEST_API_ID,
]);
const DIGITAL_PRODUCT_IDS = new Set([
    DIGITAL_BOOK_STRIPE_PRODUCT_LIVE_API_ID,
    DIGITAL_BOOK_STRIPE_PRODUCT_TEST_API_ID,
    DIGITAL_BOOK_PREORDER_STRIPE_PRODUCT_LIVE_API_ID,
    DIGITAL_BOOK_PREORDER_STRIPE_PRODUCT_TEST_API_ID,
]);
const WEB_BOOK_FULL_PRODUCT_IDS = new Set([
    WEB_BOOK_STRIPE_PRODUCT_LIVE_API_ID,
    WEB_BOOK_STRIPE_PRODUCT_TEST_API_ID,
]);
const COMPLIMENTARY_WEB_BOOK_QUALIFYING_PRODUCT_IDS = new Set([
    PHYSICAL_BOOK_STRIPE_PRODUCT_LIVE_API_ID,
    PHYSICAL_BOOK_STRIPE_PRODUCT_TEST_API_ID,
    PHYSICAL_BOOK_PREORDER_STRIPE_PRODUCT_LIVE_API_ID,
    PHYSICAL_BOOK_PREORDER_STRIPE_PRODUCT_TEST_API_ID,
    DIGITAL_BOOK_STRIPE_PRODUCT_LIVE_API_ID,
    DIGITAL_BOOK_STRIPE_PRODUCT_TEST_API_ID,
    DIGITAL_BOOK_PREORDER_STRIPE_PRODUCT_LIVE_API_ID,
    DIGITAL_BOOK_PREORDER_STRIPE_PRODUCT_TEST_API_ID,
]);

const getCartBookInviteNote = (
    cartItems?: ICartItem[],
): ICartBookInviteNote | null => {
    if (!cartItems || cartItems.length === 0) return null;

    const prioritizedItem = (
        cartItems.find((item: ICartItem) => PHYSICAL_PRODUCT_IDS.has(item.productId))
        || cartItems.find((item: ICartItem) => DIGITAL_PRODUCT_IDS.has(item.productId))
        || cartItems.find((item: ICartItem) => WEB_BOOK_FULL_PRODUCT_IDS.has(item.productId))
    );
    if (!prioritizedItem) return null;

    if (
        COMPLIMENTARY_WEB_BOOK_QUALIFYING_PRODUCT_IDS.has(prioritizedItem.productId)
        && prioritizedItem.quantity >= 2
    ) {
        return {
            productId: prioritizedItem.productId,
            text: 'Additional complimentary web books from this order can be gifted via email at checkout.',
        };
    }
    if (
        COMPLIMENTARY_WEB_BOOK_QUALIFYING_PRODUCT_IDS.has(prioritizedItem.productId)
        && prioritizedItem.quantity === 1
    ) {
        return {
            productId: prioritizedItem.productId,
            text: 'Know someone who\'d want to read it today? Add more copies and gift their complimentary web books via email at checkout.',
        };
    }
    if (
        WEB_BOOK_FULL_PRODUCT_IDS.has(prioritizedItem.productId)
        && prioritizedItem.quantity === 1
    ) {
        return {
            productId: prioritizedItem.productId,
            text: 'Know someone else who\'d enjoy the web book? Add extra copies now and gift them via email at checkout.',
        };
    }
    return null;
};

export default getCartBookInviteNote;
